module.exports = __webpack_public_path__ + "static/media/play-button-mini.cf17d034.svg";